<!-- start app-overlay-container -->
<app-overlay-container>
    <div class="wrap_close text-center my-5">
        <!-- // import app-close -->
        <app-close (click)="Filtration.close()"></app-close>
    </div>    
    <app-content-card class="d-block mb-5">
        <form [formGroup]="FiltrationForm" (ngSubmit)="submit()">
            <div class="row">
                <div class="col-12 col-md-12 wrap_full_control">
                    <app-label title="المدينة"></app-label>
                    <div class="margin_y_3">
                        <ng-select 
                            bindValue="id"
                            [clearable]="false"
                            bindLabel="cityName"
                            formControlName="city"
                            class="text-center sm"
                            placeholder="اختيار المدينة"
                            notFoundText="لا يوجد مدن متاحة!"
                            [items]="locationHandler.cities"
                            [loading]="locationHandler.isLoadingCities"
                            (change)="locationHandler.findAreaByCityId($event.id)"
                        />
                        <!-- <div class="wrap_validation">
                            <app-validation-input 
                                class="mb-0"
                                [text]="'هذا الحقل مطلوب'"
                                *ngIf="FiltrationForm.controls['city']?.touched && FiltrationForm.controls['city']?.errors"
                            />
                        </div>-->
                    </div>
                </div>
                <div class="col-12 col-md-12 wrap_full_control">
                    <app-label title="الحي"></app-label>
                    <div class="margin_y_3">
                        <ng-select 
                            bindValue="id"
                            [clearable]="false"
                            bindLabel="areaName"
                            class="text-center sm"
                            formControlName="area"
                            placeholder="اختيار الحي"
                            [items]="locationHandler.areas"
                            notFoundText="لا يوجد احياء متاحة!"
                            [loading]="locationHandler.isLoadingAreas"
                        />
                    </div>
                </div>
                <div class="col-12 col-md-12">
                    <div class="wrap_full_control">
                        <app-label title="نوع العقار" />
                        <div class="margin_y_3">
                            <ng-select 
                                bindValue="id"
                                [clearable]="false"
                                [searchable]="false"
                                placeholder="الرئيسي"
                                class="text-center sm"
                                bindLabel="categoryName"
                                formControlName="category"
                                [items]="categoryHandler.items"
                                notFoundText="لا يوجد فئة رئيسية متاحة!"
                                [loading]="categoryHandler.isLoadingItems"
                                (change)="categoryHandler.findSubCategories($event)"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-12">
                    <div class="wrap_full_control">
                        <app-label title="نوع العقار الفرعي" />
                        <div class="margin_y_3">
                            <ng-select 
                                bindValue="id"
                                [clearable]="false"
                                [searchable]="false"
                                placeholder="الفرعي"
                                class="text-center sm"
                                bindLabel="categoryName"
                                formControlName="subCategory"
                                [items]="categoryHandler.subItems"
                                notFoundText="لا يوجد فئة فرعية متاحة!"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center mt-4">
                    <app-btn 
                        title="بحث"
                        [submit]="true"
                        [disabled]="FiltrationForm.invalid || isLoading || !FiltrationForm.dirty"
                    />
                </div>                
            </div>
        </form>
    </app-content-card>
</app-overlay-container>
<!-- end app-overlay-container -->